import * as React from 'react';
import { useDispatch } from 'react-redux';
import { closeNotification } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';
import { setCartWidgetVisibility } from '../../modules/widget/actions';
import { NOTIFICATION_ID } from './modules/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ViewCartButton(props) {
  const {
    __
  } = useTranslator();
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(Button, {
    type: "button",
    ...props,
    onClick: () => {
      dispatch(closeNotification(NOTIFICATION_ID));
      dispatch(setCartWidgetVisibility(true));
    },
    children: __('View cart')
  });
}